import { render, staticRenderFns } from "./employment-doc-down.vue?vue&type=template&id=232bed65"
import script from "./employment-doc-down.vue?vue&type=script&lang=js"
export * from "./employment-doc-down.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports